import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { DEFAULT_LANGUAGE, SupportedLanguage, SUPPORTED_LANGUAGES } from './constants';
import { resolveInitialLanguage, setStoredLanguage } from './language';

export const DEFAULT_NAMESPACE = 'common' as const;

type NamespaceMap = Record<string, Record<string, unknown>>;

const enModules = import.meta.glob('./en/*.json', { eager: true });
const esModules = import.meta.glob('./es/*.json', { eager: true });

function modulesToNamespaces(modules: Record<string, unknown>): NamespaceMap {
  return Object.entries(modules).reduce((acc, [path, mod]) => {
    const namespace = path.replace(/^\.\/[^/]+\/(.+)\.json$/, '$1');
    const moduleValue = (mod as { default?: unknown }).default ?? mod;
    acc[namespace] = moduleValue as Record<string, unknown>;
    return acc;
  }, {} as NamespaceMap);
}

const resources = {
  en: modulesToNamespaces(enModules),
  es: modulesToNamespaces(esModules),
} as Record<SupportedLanguage, NamespaceMap>;

export const NAMESPACES = Object.keys(resources.en);

if (!i18n.isInitialized) {
  const initialLanguage = resolveInitialLanguage();

  void i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: initialLanguage,
      fallbackLng: DEFAULT_LANGUAGE,
      supportedLngs: [...SUPPORTED_LANGUAGES],
      ns: NAMESPACES,
      defaultNS: DEFAULT_NAMESPACE,
      interpolation: {
        escapeValue: false,
      },
      react: {
        useSuspense: false,
      },
      returnNull: false,
    })
    .then(() => {
      i18n.on('languageChanged', (lng) => {
        if ((SUPPORTED_LANGUAGES as readonly string[]).includes(lng)) {
          setStoredLanguage(lng as SupportedLanguage);
        }
      });
    });
}

export default i18n;
